document.addEventListener('DOMContentLoaded', function() {
  if (window.matchMedia('(max-width: 989px)').matches) return;

  var megaPanel = document.getElementById('MegaDropdown-shared');
  if (!megaPanel) return;

  var timeout;
  var triggers = document.querySelectorAll('.mega-trigger');
  var nav = megaPanel.closest('nav') || megaPanel.parentElement;

  function openMenu() {
    clearTimeout(timeout);
    megaPanel.classList.add('is-open');
  }

  function closeMenu() {
    timeout = setTimeout(function() {
      megaPanel.classList.remove('is-open');
    }, 200);
  }

  triggers.forEach(function(trigger) {
    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', closeMenu);
  });

  megaPanel.addEventListener('mouseenter', openMenu);
  megaPanel.addEventListener('mouseleave', closeMenu);
});

(function() {
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;
    if (e.target.closest('a, button, .swatch, .quick-add, input')) return;
    var isMedia = e.target.closest('.card__media, .card__inner') || e.target.tagName === 'IMG';
    if (!isMedia) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      window.location.href = link.href;
    }
  }, true);
})();



// Swatch carousel arrows voor related products
(function() {
  var leftArrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var rightArrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';

  function initSwatchArrows() {
    document.querySelectorAll('.related-products .color-meta-field').forEach(function(field) {
      if (field.querySelector('.swatch-arrow')) return; // al geïnitialiseerd

      var container = field.querySelector('.product-swatches');
      if (!container) return;

      var items = container.querySelectorAll('.product-item');
      if (items.length <= 3) return; // geen pijltjes nodig

      // Maak pijltjes
      var leftBtn = document.createElement('button');
      leftBtn.className = 'swatch-arrow swatch-arrow--left at-start';
      leftBtn.innerHTML = leftArrowSvg;
      leftBtn.setAttribute('aria-label', 'Vorige');

      var rightBtn = document.createElement('button');
      rightBtn.className = 'swatch-arrow swatch-arrow--right';
      rightBtn.innerHTML = rightArrowSvg;
      rightBtn.setAttribute('aria-label', 'Volgende');

      field.appendChild(leftBtn);
      field.appendChild(rightBtn);

      // Scroll amount: 1 swatch + gap
      var scrollAmount = 44;

      leftBtn.addEventListener('click', function() {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', function() {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      // Update pijltje states bij scroll
      function updateArrows() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;

        if (scrollLeft <= 2) {
          leftBtn.classList.add('at-start');
        } else {
          leftBtn.classList.remove('at-start');
        }

        if (scrollLeft >= maxScroll - 2) {
          rightBtn.classList.add('at-end');
        } else {
          rightBtn.classList.remove('at-end');
        }
      }

      container.addEventListener('scroll', updateArrows);
      updateArrows();
    });
  }

  document.addEventListener('DOMContentLoaded', initSwatchArrows);

  // Observer voor dynamisch geladen content
  var observer = new MutationObserver(function() { initSwatchArrows(); });
  var target = document.querySelector('product-recommendations') || document.body;
  observer.observe(target, { childList: true, subtree: true });
})();
